{{#each this}}
  <li class='gallery__item' id={{id}}>
    <img
      class='gallery__icon'
      src='{{poster_path}}'
      alt='{{title}}'
      width='280'
      height='394'
      loading='lazy'
    />
    <div class='item__description'>
      <p class='item__title'>{{title}}</p>
      <p class='item__info'>
        {{genre_ids}}&nbsp;
        <span class='item__info--genres'>&nbsp;{{release_date}}</span>
      </p>
    </div>
  </li>
{{/each}}